import React from 'react';

type Props = {
  /** Star rating to be displayed */
  rating: number;
  /** Icon size of the star to be displayed */
  size: 16 | 24 | 32 | 48;
};

export const StarPartial = (props: Props) => {
  const { rating, size } = props;
  const id = `starPercentage_${rating}`;

  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <defs>
        <linearGradient id={id}>
          <stop offset={rating} stopColor="#FFBA00" />
          <stop offset={1 - rating} stopColor="white" />
        </linearGradient>
      </defs>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0518 12.05L20.3033 10.9853L16.9988 3.64698C16.8225 3.25335 16.4314 3 16.0001 3C15.5688 3 15.1777 3.25335 15.0014 3.64698L11.6968 10.9849L3.94853 12.05C3.53505 12.1081 3.19007 12.3952 3.05781 12.7913C2.92554 13.1873 3.02877 13.6241 3.32433 13.9191L9.03783 19.623L7.60593 27.706C7.53045 28.1254 7.70477 28.5506 8.05296 28.7963C8.40115 29.042 8.86016 29.0638 9.23003 28.8521L16 24.96L22.77 28.8523C23.14 29.064 23.599 29.0422 23.9472 28.7964C24.2954 28.5505 24.4697 28.1252 24.394 27.7058L22.9621 19.6228L28.6756 13.9189C28.9711 13.624 29.0742 13.1873 28.9421 12.7914C28.8099 12.3954 28.4652 12.1083 28.0518 12.05Z"
        fill={`url(#${id})`}
      />
    </svg>
  );
};

export default true;
